import React, { useState } from 'react';
import { Scale, Copyright, Lightbulb, Building2, ArrowRight, ChevronRight } from 'lucide-react';
import { servicesMenu } from '../data/mock';

const iconMap = {
  Scale: Scale,
  Copyright: Copyright,
  Lightbulb: Lightbulb,
  Building2: Building2,
};

export const MegaMenu = ({ isOpen, onClose }) => {
  const [activeService, setActiveService] = useState(servicesMenu[0]);

  if (!isOpen) return null;

  return (
    <div
      className="absolute top-full left-0 right-0 bg-white shadow-2xl"
      onMouseLeave={onClose}
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-12">
          {/* Left Side - Main Services */}
          <div className="col-span-4 bg-gray-50 border-r border-gray-200 py-8">
            <div className="px-6 mb-6">
              <h3 className="text-sm font-semibold text-[#D4AF37] uppercase tracking-wider">
                Our Services
              </h3>
            </div>
            
            <div className="space-y-1">
              {servicesMenu.map((service) => {
                const Icon = iconMap[service.icon];
                const isActive = activeService.id === service.id;
                
                return (
                  <div
                    key={service.id}
                    onMouseEnter={() => setActiveService(service)}
                    className={`group relative px-6 py-4 cursor-pointer transition-all duration-200 border-l-4 ${
                      isActive
                        ? 'bg-white border-[#D4AF37]'
                        : 'border-transparent hover:bg-white/50'
                    }`}
                  >
                    <div className="flex items-center space-x-4">
                      <div className={`flex-shrink-0 w-12 h-12 rounded-xl flex items-center justify-center transition-colors ${
                        isActive
                          ? 'bg-[#D4AF37] text-[#0A1F44]'
                          : 'bg-white text-[#D4AF37]'
                      }`}>
                        <Icon className="w-6 h-6" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <h4 className={`font-semibold text-base mb-1 transition-colors ${
                          isActive ? 'text-[#0A1F44]' : 'text-gray-700'
                        }`}>
                          {service.name}
                        </h4>
                        <p className="text-xs text-gray-600 leading-relaxed">
                          {service.description}
                        </p>
                      </div>
                      <ChevronRight className={`flex-shrink-0 w-5 h-5 transition-all ${
                        isActive
                          ? 'text-[#D4AF37] opacity-100'
                          : 'text-gray-400 opacity-0 group-hover:opacity-100'
                      }`} />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right Side - Sub Services */}
          <div className="col-span-8 py-8 px-8">
            <div className="mb-6">
              <h3 className="text-2xl font-bold text-[#0A1F44] mb-2">
                {activeService.name}
              </h3>
              <p className="text-gray-600">
                Explore our specialized {activeService.name.toLowerCase()} offerings
              </p>
            </div>

            {/* Sub Services Grid */}
            <div className="grid grid-cols-2 gap-4 mb-8">
              {activeService.subServices.map((subService, index) => (
                <a
                  key={index}
                  href={subService.link}
                  className="group bg-gray-50 rounded-xl p-4 hover:bg-white hover:shadow-md transition-all duration-200 border border-transparent hover:border-[#D4AF37]/20"
                >
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <h4 className="font-semibold text-[#0A1F44] mb-1 group-hover:text-[#D4AF37] transition-colors">
                        {subService.name}
                      </h4>
                      <p className="text-xs text-gray-600">
                        {subService.oneLiner}
                      </p>
                    </div>
                    <ArrowRight className="w-5 h-5 text-gray-400 opacity-0 group-hover:opacity-100 group-hover:text-[#D4AF37] group-hover:translate-x-1 transition-all flex-shrink-0 mt-1" />
                  </div>
                </a>
              ))}
            </div>

            {/* Bottom Action Bar */}
            <div className="flex items-center justify-between pt-6 border-t border-gray-200">
              <div className="text-sm text-gray-600">
                Need help choosing the right service?{' '}
                <a href="/contact" className="text-[#D4AF37] hover:text-[#0A1F44] font-semibold">
                  Talk to our legal team →
                </a>
              </div>
              <a
                href={`/services/${activeService.name.toLowerCase().replace(/\s+/g, '-')}`}
                className="liquid bg-[#D4AF37] hover:bg-[#B8941F] text-[#0A1F44] font-semibold py-3 px-6 rounded-lg transition-all"
              >
                View All {activeService.name}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
